export const SAO_PAULO_TIMEZONE = 'America/Sao_Paulo';
export const SAO_PAULO_OFFSET = '-03:00';
export const INVITE_START_PLACEHOLDER = 'dd/mm/aaaa hh:mm';

export const getSaoPauloLocalValue = (date = new Date()) => {
  const formatter = new Intl.DateTimeFormat('sv-SE', {
    timeZone: SAO_PAULO_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  return formatter.format(date).replace(' ', 'T');
};

export const getSaoPauloNowDate = () => {
  const localValue = getSaoPauloLocalValue();
  return new Date(`${localValue}:00${SAO_PAULO_OFFSET}`);
};

export const getSaoPauloNowParts = () => {
  const [datePart, timePart] = getSaoPauloLocalValue().split('T');
  return { datePart, timePart };
};

export const formatInviteStartInput = (value) => {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 12);
  if (!digits) return '';

  let formatted = digits.slice(0, 2);
  if (digits.length > 2) formatted += `/${digits.slice(2, 4)}`;
  if (digits.length > 4) formatted += `/${digits.slice(4, 8)}`;
  if (digits.length > 8) formatted += ` ${digits.slice(8, 10)}`;
  if (digits.length > 10) formatted += `:${digits.slice(10, 12)}`;
  return formatted;
};

export const buildMaskedInviteStartValue = (datePart, timePart) => {
  if (!datePart) return '';
  const [year = '', month = '', day = ''] = String(datePart || '').split('-');
  if (!year || !month || !day) return '';
  const normalizedTime = String(timePart || '00:00').slice(0, 5);
  return `${day}/${month}/${year} ${normalizedTime}`;
};

export const parseInviteStartInput = (value) => {
  const normalized = String(value || '').trim();
  const match = normalized.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/);
  if (!match) return null;

  const [, dayText, monthText, yearText, hourText, minuteText] = match;
  const day = Number(dayText);
  const month = Number(monthText);
  const year = Number(yearText);
  const hour = Number(hourText);
  const minute = Number(minuteText);

  if (month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) {
    return null;
  }

  const validationDate = new Date(Date.UTC(year, month - 1, day, hour, minute));
  if (
    validationDate.getUTCFullYear() !== year ||
    validationDate.getUTCMonth() !== month - 1 ||
    validationDate.getUTCDate() !== day ||
    validationDate.getUTCHours() !== hour ||
    validationDate.getUTCMinutes() !== minute
  ) {
    return null;
  }

  const iso = new Date(`${yearText}-${monthText}-${dayText}T${hourText}:${minuteText}:00${SAO_PAULO_OFFSET}`).toISOString();
  const datePart = `${yearText}-${monthText}-${dayText}`;
  const timePart = `${hourText}:${minuteText}`;

  return {
    iso,
    masked: `${dayText}/${monthText}/${yearText} ${hourText}:${minuteText}`,
    localValue: `${datePart}T${timePart}`,
    datePart,
    timePart,
  };
};

export const buildInviteStartAtIso = (value) => parseInviteStartInput(value)?.iso || null;

export const formatSaoPauloDateTimeLabel = (value) => {
  if (!value) return 'Nao registrado';
  try {
    return new Date(value).toLocaleString('pt-BR', {
      timeZone: SAO_PAULO_TIMEZONE,
      hour12: false,
    });
  } catch {
    return 'Nao registrado';
  }
};

export const formatSaoPauloDateTimeForInput = (value) => {
  if (!value) return '';
  try {
    const formatter = new Intl.DateTimeFormat('sv-SE', {
      timeZone: SAO_PAULO_TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    const localValue = formatter.format(new Date(value)).replace(' ', 'T');
    const [datePart, timePart] = localValue.split('T');
    return buildMaskedInviteStartValue(datePart, timePart);
  } catch {
    return '';
  }
};
